import { RegionDeliveryRangeSettingsService } from '@/backend/market'
import { RegionDeliveryRangeSettingRepository } from '../../domain/repositories/RegionDeliveryRangeSettingRepository'
import { RegionDeliveryRangeSettingModel } from '../models/RegionDeliveryRangeSettingModel'
import type { RegionDeliveryRangeSettingEntity } from '../../domain/entities/RegionDeliveryRangeSettingEntity'
import type { CreateUpdateRegionDeliveryRangeSettingEntity } from '../../domain/entities/CreateUpdateRegionDeliveryRangeSettingEntity'
import { CreateUpdateRegionDeliveryRangeSettingModel } from '../models/CreateUpdateRegionDeliveryRangeSettingModel'

export class RegionDeliveryRangeSettingRepositoryImpl
  implements RegionDeliveryRangeSettingRepository
{
  async getRegionDeliveryRangeSettings(): Promise<
    RegionDeliveryRangeSettingEntity[] | { error: true }
  > {
    try {
      const response =
        await RegionDeliveryRangeSettingsService.getRegionDeliveryRangeSettingsAdmin()
      const regionDeliveryRangeSettingModels = response.regionDeliveryRangeSettings?.map(
        (item) => new RegionDeliveryRangeSettingModel(item)
      )
      return regionDeliveryRangeSettingModels ?? []
    } catch {
      return { error: true }
    }
  }
  async createRegionDeliveryRangeSetting(
    settingData: CreateUpdateRegionDeliveryRangeSettingEntity
  ): Promise<{ success: true } | { error: true }> {
    const settingModel = new CreateUpdateRegionDeliveryRangeSettingModel(settingData)
    try {
      await RegionDeliveryRangeSettingsService.postRegionDeliveryRangeSettingAdmin({
        requestBody: settingModel
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateRegionDeliveryRangeSetting(
    id: number,
    settingData: CreateUpdateRegionDeliveryRangeSettingEntity
  ): Promise<{ success: true } | { error: true }> {
    const settingModel = new CreateUpdateRegionDeliveryRangeSettingModel(settingData)
    try {
      await RegionDeliveryRangeSettingsService.putRegionDeliveryRangeSettingAdmin({
        id,
        requestBody: settingModel
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
